import React, { useEffect, useState } from 'react';
import { Button, Checkbox, Group, Modal, Stack, Text } from '@mantine/core';

interface FullInitialSyncModalProps {
  opened: boolean;
  objectLabel: string;
  loading: boolean;
  onClose: () => void;
  onConfirm: (ignoreExistingRanges: boolean) => void;
}

export const FullInitialSyncModal: React.FC<FullInitialSyncModalProps> = ({
  opened,
  objectLabel,
  loading,
  onClose,
  onConfirm,
}) => {
  const [ignoreExistingRanges, setIgnoreExistingRanges] = useState(false);

  useEffect(() => {
    if (!opened) {
      setIgnoreExistingRanges(false);
    }
  }, [opened]);

  return (
    <Modal opened={opened} onClose={onClose} title="Full Initial Sync" centered>
      <Stack spacing="md">
        <Text size="sm">
          Re-fetch every <strong>{objectLabel}</strong> item from the initial sync start date. Items
          already synced are updated in place, so fields missing from an earlier sync are filled in.
          Nothing is deleted.
        </Text>
        <Checkbox
          checked={ignoreExistingRanges}
          onChange={(event) => setIgnoreExistingRanges(event.currentTarget.checked)}
          label="Ignore earlier sync tasks"
          description="Fetch every date range, including ranges held by failed, pending or stuck tasks from an earlier sync. A range still being fetched may be fetched twice."
        />
        <Group position="right" mt="md">
          <Button variant="outline" onClick={onClose}>
            Cancel
          </Button>
          <Button loading={loading} onClick={() => onConfirm(ignoreExistingRanges)}>
            Run Full Sync
          </Button>
        </Group>
      </Stack>
    </Modal>
  );
};
